import { groq } from '#imports';

export function getQuery({ themeId }) {
  return groq`count(*[_type == "article" && theme._ref == "${themeId}" && !(_id in path('drafts.**'))])`;
}
